import { useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Alert, Button } from 'react-bootstrap'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from 'components/shared/flex'
import { A4 } from 'components/shared/print'
import template from 'components/../../public/sashidashihyo.jpg'
import './preview.scss'
import styled from 'styled-components'
import moment from 'moment'
import _ from 'lodash'
import { Sample, SampleSearchForm } from 'entities/sample'
import { useFetchSamplesApi } from 'api/sample'
import { setPageSize } from 'utils/util'

type Props = {
    history: H.History
}

const Th = styled.th`
    border-right: solid 1px black;
    background-color: #e1e1e1;
    padding: 5px 10px;
    text-align: center;
    font-size: 14px;
    vertical-align: center;
`

const Td = styled.td`
    border-right: solid 1px black;
    padding: 5px;
`

const PreviewRequestPostListPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<{ sampleId: string }>()
    const isHomeTest = !!process.env.REACT_APP_IS_HOME_TEST
    const [post, setPost] = useState<{ lightPost: number; middlePost: number; weightyPost: number }>({
        lightPost: 0,
        middlePost: 0,
        weightyPost: 0,
    })

    const searchForm = useForm<SampleSearchForm>({
        perPage: 10000,
        ordering: 'sample_created_at',
        sampleIdIn: query.sampleId ? String(query.sampleId) : undefined,
    })
    const samplesApi = useFetchSamplesApi(searchForm)

    useEffect(() => {
        samplesApi.execute()
        setPageSize('portrait')
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(samplesApi.loading)
    }, [samplesApi.loading])

    const checklistChunk = (): Sample[][] => {
        if (samplesApi.response.results) {
            return _.chunk(
                samplesApi.response.results.sort((a, b) => a.institution!.id! - b.institution!.id!),
                9
            )
        }
        return []
    }
    // プリンター不良のため、後納郵便差出票に記載する重さを計算が一部変更された。
    //  下記の関数は現在別の関数（calculateNormalPaperResultsCounts）に置き換えられている。
    // const calculateResultsCounts = (sampleList: Sample[]) => {
    //     let lightPostCount = 0 // 1通あたり 270円
    //     let middlePostCount = 0 // 1通あたり 320円
    //     let weightyPostCount = 0 // 1通あたり 510円

    //     sampleList.forEach((sample) => {
    //         const productItems = sample.productItems?.length
    //         if (!productItems) {
    //             return
    //         }

    //         if (isHomeTest) {
    //             if (productItems === 1) {
    //                 lightPostCount += 1
    //             } else {
    //                 middlePostCount += 1
    //             }
    //         } else {
    //             const resultPackingType = sample.institution?.resultPackingType
    //             if (!resultPackingType) {
    //                 return
    //             }
    //             // 医療の場合は「冊子」と「バラ」の２パターンの結果表返送方法がある
    //             if (resultPackingType === '冊子') {
    //                 if (productItems === 7) {
    //                     weightyPostCount += 1
    //                 } else if (productItems === 1) {
    //                     lightPostCount += 1
    //                 } else {
    //                     middlePostCount += 1
    //                 }
    //             } else {
    //                 if (productItems <= 2) {
    //                     middlePostCount += 1
    //                 } else {
    //                     weightyPostCount += 1
    //                 }
    //             }
    //         }
    //     })
    //     return {
    //         lightPost: lightPostCount,
    //         middlePost: middlePostCount,
    //         weightyPost: weightyPostCount,
    //     }
    // }

    // プリンター不良のため、一時普通紙印刷に変更
    // 結果表の重さも変わるため、普通紙用の後納郵便差出票に記載する重さを計算
    const calculateNormalPaperResultsCounts = (sampleList: Sample[]) => {
        let lightPostCount = 0 // 1通あたり 270円
        let middlePostCount = 0 // 1通あたり 320円
        let weightyPostCount = 0 // 1通あたり 510円

        sampleList.forEach((sample) => {
            const productItems = sample.productItems?.length
            if (!productItems) {
                return
            }

            if (isHomeTest) {
                if (productItems === 1) {
                    lightPostCount += 1
                } else {
                    middlePostCount += 1
                }
            } else {
                const resultPackingType = sample.institution?.resultPackingType
                if (!resultPackingType) {
                    return
                }
                // 医療の場合は「冊子」と「バラ」の２パターンの結果表返送方法がある
                if (resultPackingType === '冊子') {
                    if (productItems === 1) {
                        lightPostCount += 1
                    } else {
                        middlePostCount += 1
                    }
                } else {
                    if (productItems <= 2) {
                        middlePostCount += 1
                    } else {
                        weightyPostCount += 1
                    }
                }
            }
        })
        return {
            lightPost: lightPostCount,
            middlePost: middlePostCount,
            weightyPost: weightyPostCount,
        }
    }

    useEffect(() => {
        // setPost(calculateResultsCounts(samplesApi.response.results))
        // プリンター不調のため、普通紙印刷用の重さ計算に一時切り替え（2024/3/12~）
        setPost(calculateNormalPaperResultsCounts(samplesApi.response.results))
    }, [samplesApi.response.results])

    return (
        <div className="preview-request-form">
            <Flex className="no-print" style={{ marginLeft: 20 }} alignItems="center">
                <div style={{ padding: 15 }}>
                    <Button
                        style={{ width: 200 }}
                        onClick={() => {
                            window.print()
                        }}
                    >
                        印刷プレビュー
                    </Button>
                </div>

                {/* 冊子返送の医療機関はレアケースなので、結果返送時にアラートで教えてあげる */}
                {samplesApi.response.results.some((sample) => sample.institution?.resultPackingType !== '冊子') && (
                    <Alert style={{ marginTop: 10 }} variant="danger">
                        <div>結果票の発送パターンが冊子以外の施設が含まれています</div>
                        <div style={{ marginTop: 10 }}>
                            該当施設：
                            {[
                                ...new Set(
                                    samplesApi.response.results
                                        .filter((sample) => sample.institution?.resultPackingType !== '冊子')
                                        .map((sample) => sample.institution?.name)
                                ),
                            ].join(', ')}
                        </div>
                    </Alert>
                )}
            </Flex>
            <A4 padding={0} landscape={false}>
                <div className="page-root" style={{ width: '100.5%', height: '100%', position: 'relative' }}>
                    <img src={template} style={{ objectFit: 'contain', width: '100%' }} />
                    {/*  重さごとの通数  */}

                    <div style={{ position: 'absolute', left: 402, top: 446, fontSize: 17, width: 69, textAlign: 'center' }}>
                        {post.lightPost > 0 ? post.lightPost.toLocaleString() : ''}
                    </div>
                    <div style={{ position: 'absolute', left: 402, top: 480, fontSize: 17, width: 69, textAlign: 'center' }}>
                        {post.middlePost > 0 ? post.middlePost.toLocaleString() : ''}
                    </div>
                    <div style={{ position: 'absolute', left: 402, top: 514, fontSize: 17, width: 69, textAlign: 'center' }}>
                        {post.weightyPost > 0 ? post.weightyPost.toLocaleString() : ''}
                    </div>
                    {/*  重さごとの通数×金額  */}

                    <div style={{ position: 'absolute', left: 555, top: 446, fontSize: 17, width: 78, textAlign: 'center' }}>
                        {post.lightPost * 270 > 0 ? (post.lightPost * 270).toLocaleString() : ''}
                    </div>
                    <div style={{ position: 'absolute', left: 555, top: 480, fontSize: 17, width: 78, textAlign: 'center' }}>
                        {post.middlePost * 320 > 0 ? (post.middlePost * 320).toLocaleString() : ''}
                    </div>
                    <div style={{ position: 'absolute', left: 555, top: 514, fontSize: 17, width: 78, textAlign: 'center' }}>
                        {post.weightyPost * 510 > 0 ? (post.weightyPost * 510).toLocaleString() : ''}
                    </div>
                    {/* 通数の合計  */}
                    <div style={{ position: 'absolute', left: 402, top: 1036, fontSize: 17, width: 69, textAlign: 'center' }}>
                        {post.lightPost + post.middlePost + post.weightyPost}
                    </div>
                    {/* 金額の合計 */}
                    <div style={{ position: 'absolute', left: 555, top: 1036, fontSize: 17, width: 78, textAlign: 'center' }}>
                        {(post.lightPost * 270 + post.middlePost * 320 + post.weightyPost * 510).toLocaleString()}
                    </div>
                </div>
            </A4>
            {checklistChunk().map((samples, index) => {
                return (
                    <A4 padding={10} landscape={false} key={'checklist-' + index}>
                        <div className={'preview-request-list'} style={{ width: '100%', height: '100%', position: 'relative' }}>
                            <div style={{ width: '100%', marginBottom: 30, marginTop: 30 }}>
                                <div style={{ width: '100%', textAlign: 'right', marginBottom: 30 }}>{moment().format('YYYY/MM/DD')}</div>
                                <div style={{ fontSize: 25, fontWeight: 'bold', width: '100%', textAlign: 'center' }}>郵便書類チェックリスト</div>
                            </div>

                            <table style={{ width: '100%', border: 'solid 1px black', borderRightWidth: 0, borderBottomWidth: 0, fontSize: 12 }}>
                                <thead>
                                    <tr style={{ borderBottom: 'solid 1px black' }}>
                                        <Th style={{ fontSize: 12, width: 30 }}>#</Th>
                                        <Th style={{ fontSize: 12, width: 100 }}>検体コード</Th>
                                        <Th style={{ fontSize: 12, width: 150 }}>{isHomeTest ? 'お届け先のお名前' : 'お届け先施設'}</Th>
                                        {!isHomeTest && <Th style={{ fontSize: 12, width: 120 }}>患者氏名</Th>}
                                        <Th style={{ fontSize: 12, width: 140 }}>結果表</Th>
                                        {!isHomeTest && (
                                            <Th style={{ fontSize: 12, width: 90 }}>
                                                <div>
                                                    結果表
                                                    <br />
                                                    (控え)
                                                </div>
                                            </Th>
                                        )}
                                        <Th style={{ fontSize: 12, width: 90 }}>パンフレット</Th>
                                        {isHomeTest && (
                                            <Th style={{ fontSize: 12, width: 85 }}>
                                                ストーリー
                                                <br />
                                                冊子
                                            </Th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {new Array(9).fill(0).map((_, sampleIndex) => {
                                        const sample: Sample | undefined = samples[sampleIndex]
                                        return (
                                            <tr key={sample?.id} style={{ borderBottom: 'solid 1px black' }}>
                                                <Td style={{ verticalAlign: 'inherit' }}>
                                                    <div style={{ minHeight: 30, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <div>{sampleIndex + 1}</div>
                                                    </div>
                                                </Td>
                                                <Td>{sample?.code}</Td>
                                                <Td style={{ fontSize: 10, padding: '0 5px' }}>
                                                    {isHomeTest
                                                        ? `${sample?.patient?.familyName || ''} ${sample?.patient?.givenName || ''}(${
                                                              sample?.patient?.familyNameKana || ''
                                                          } ${sample?.patient?.givenNameKana || ''})`
                                                        : sample?.institution?.name}
                                                </Td>
                                                {!isHomeTest && (
                                                    <Td style={{ fontSize: 10, padding: '0 5px' }}>{`${sample?.patient?.familyNameKana || ''} ${
                                                        sample?.patient?.givenNameKana || ''
                                                    }`}</Td>
                                                )}
                                                <Td>
                                                    <Flex style={{ fontSize: 10 }} flexWrap="wrap">
                                                        {sample?.productItems?.map((pi, index) => {
                                                            return (
                                                                <Flex key={'prod' + index} justifyContent="center" alignItems="center" className="">
                                                                    <div style={{ marginRight: 5 }}>{pi.name}</div>
                                                                    <div style={{ width: 10, height: 10, border: 'solid 1px black' }}></div>
                                                                </Flex>
                                                            )
                                                        })}
                                                    </Flex>
                                                </Td>
                                                {!isHomeTest && (
                                                    <Td>
                                                        <Flex justifyContent="center">
                                                            <div style={{ width: 20, height: 20, border: 'solid 1px black' }}></div>
                                                        </Flex>
                                                    </Td>
                                                )}
                                                <Td>
                                                    <Flex justifyContent="center">
                                                        <div style={{ width: 20, height: 20, border: 'solid 1px black' }}></div>
                                                    </Flex>
                                                </Td>
                                                {isHomeTest && (
                                                    <Td>
                                                        <Flex justifyContent="center">
                                                            <div style={{ width: 20, height: 20, border: 'solid 1px black' }}></div>
                                                        </Flex>
                                                    </Td>
                                                )}
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>

                            <Flex justifyContent="flex-end" style={{ marginTop: 30 }}>
                                <div>
                                    <table style={{ fontSize: 14, border: 'solid 1px black' }}>
                                        <thead style={{ backgroundColor: '#e1e1e1', borderBottom: 'solid 1px black', textAlign: 'center' }}>
                                            <tr>
                                                <th style={{ width: 100, borderRight: 'solid 1px black' }}>封入者</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ borderRight: 'solid 1px black' }}>
                                                    <div style={{ height: 60 }}></div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </Flex>
                        </div>
                    </A4>
                )
            })}
        </div>
    )
}

export default withRouter(PreviewRequestPostListPage)
